<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'诺米的日记 -《使魔计划》'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      name="fade"
    >
      <div
        @touchmove.prevent
        class="preloading preloading-smjh"
        v-show="preloadingShow"
      ></div>
    </transition>

    <Header v-if="true" :config="headerConfig" :isShowInfo="true" />

    <!-- 登录弹窗 -->
    <Login
      v-if="isShowLogin"
      v-on:channelCallback="selectCallback"
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      channelTips="角色UID可在游戏中—设置—UID查看"
    ></Login>
    <Os
      v-if="isShowOs"
      v-on:selectCallback="selectCallback"
      v-on:logoutCallback="osCancell"
      :gameName="gameName"
    ></Os>

    <div :class="'home-page home-page-' + diaryState">
      <div class="diary-content">
        <div
          :class="'diary-title diary-title-' + turnpageState"
          title="日记封面页面"
        >
          <div class="game-player-info">
            <span class="os">{{ userInfo.server_name }}</span>
            <span class="rid">{{ userInfo.role_name }}</span>
          </div>
        </div>
        <div :class="'open-btn open-btn-' + openBtnS" @click="openBtn()"></div>
        <div class="diary-bg"></div>
        <div :class="'nav-label nav-label-' + navNum" title="导航按钮">
          <div>
            <a href="javascript:;" @click="turnPagesBtn(1)" title="日记"></a>
            <a href="javascript:;" @click="turnPagesBtn(2)" title="奖励"></a>
            <a href="javascript:;" @click="turnPagesBtn(3)" title="详情"></a>
          </div>
        </div>
        <div :class="'diary-main diary-main-' + navNum" v-if="turnpageState">
          <div class="main-page page-diary-1">
            <div :class="'my-diary-box diary-' + pageNum">
              <div
                class="page page-1"
                :style="{ 'z-index': 17 }"
                title="第一篇-上"
              >
                <div
                  :class="'date-label-btn red-' + is_red"
                  title="日期标签按钮"
                  @click="openCurrentPage()"
                ></div>
                <div :class="'page-ani-1 page-ani-' + pageAniAll[1].ani">
                  <div class="describe weather"></div>
                  <div class="describe describe-1"></div>
                  <div class="describe describe-2"></div>
                  <div class="describe describe-3"></div>
                  <div class="describe describe-4"></div>
                  <div class="describe describe-5"></div>
                  <div class="describe describe-6"></div>
                  <div :class="'btn-box btn-box-' + pageAniAll[1].select">
                    <div
                      class="describe describe-7"
                      @click="thisPage(0, 1)"
                    ></div>
                    <div
                      class="describe describe-8"
                      @click="thisPage(0, 2)"
                    ></div>
                  </div>
                  <div
                    :class="
                      'describe describe-9 describe-select-' +
                        pageAniAll[1].select
                    "
                  ></div>
                  <div
                    :class="
                      'describe jump-page jump-select-' + pageAniAll[1].select
                    "
                    @click="jumpPage(pageAniAll[1].select, 2)"
                  ></div>
                </div>
                <div class="bottom-number">1/13</div>
              </div>
              <div
                class="page page-2"
                :style="{ 'z-index': 16 }"
                title="第一篇-下"
              >
                <div :class="'page-ani-2 page-ani-' + pageAniAll[2].ani">
                  <div
                    :class="'date-label-btn red-' + is_red"
                    title="日期标签按钮"
                    @click="openCurrentPage()"
                  ></div>
                  <div class="describe weather"></div>
                  <div class="describe describe-1"></div>
                  <div class="describe describe-2"></div>
                  <div class="describe describe-3"></div>
                  <div :class="'btn-box btn-box-' + pageAniAll[2].select">
                    <div
                      class="describe describe-4"
                      @click="thisPage(1, 2)"
                    ></div>
                    <div
                      class="describe describe-5"
                      @click="thisPage(1, 1)"
                    ></div>
                  </div>
                  <div
                    :class="
                      'describe describe-6 describe-select-' +
                        pageAniAll[2].select
                    "
                  ></div>
                  <div :class="'subpage-page subpage-' + pageAniAll[2].select">
                    <div class="describe describe-7"></div>
                    <div class="describe describe-8"></div>
                    <div
                      v-if="diary_list[0].is_get == 0"
                      :class="
                        'describe describe-9 call-to-mind-btn lqjl-' +
                          diary_list[0].is_yes
                      "
                      @click="resultPage(1, diary_list[0].is_yes, 1)"
                    >
                      <b>剩余次数：{{ activeInfo.retry_time }}</b>
                    </div>
                    <div
                      v-else
                      class="describe describe-9 call-to-mind-btn ylq-btn"
                    ></div>
                    <div
                      v-if="diary_list[0].is_yes == 1"
                      :class="
                        'describe jump-page jump-select-' + diary_list[0].is_yes
                      "
                      @click="jumpPage(pageAniAll[1].select, 1)"
                    ></div>
                  </div>
                </div>
                <div
                  v-if="activeInfo.number == 1"
                  :class="'daily-task-btn daily-' + is_get + ' task-' + my_get"
                  @click="everyday()"
                ></div>
                <div class="bottom-number">2/13</div>
              </div>
              <div
                class="page page-3"
                :style="{ 'z-index': 15 }"
                title="第二篇-上"
              >
                <div :class="'page-ani-3 page-ani-' + pageAniAll[3].ani">
                  <div
                    :class="'date-label-btn red-' + is_red"
                    title="日期标签按钮"
                    @click="openCurrentPage()"
                  ></div>
                  <div class="describe weather"></div>
                  <div class="describe describe-1"></div>
                  <div class="describe describe-2"></div>
                  <div class="describe describe-3"></div>
                  <div class="describe describe-4"></div>
                  <div :class="'btn-box btn-box-' + pageAniAll[3].select">
                    <div
                      class="describe describe-5"
                      @click="thisPage(2, 2)"
                    ></div>
                    <div
                      class="describe describe-6"
                      @click="thisPage(2, 1)"
                    ></div>
                  </div>
                  <div
                    :class="
                      'describe describe-7 describe-select-' +
                        pageAniAll[3].select
                    "
                  ></div>
                  <div :class="'subpage-page subpage-' + pageAniAll[3].select">
                    <div class="describe describe-8"></div>
                    <div
                      :class="
                        'describe jump-page jump-select-' + pageAniAll[3].select
                      "
                      @click="jumpPage(pageAniAll[3].select, 4)"
                    ></div>
                  </div>
                </div>
                <div class="bottom-number">3/13</div>
              </div>
              <div
                class="page page-4"
                :style="{ 'z-index': 14 }"
                title="第二篇-下"
              >
                <div :class="'page-ani-4 page-ani-' + pageAniAll[4].ani">
                  <div
                    :class="'date-label-btn red-' + is_red"
                    title="日期标签按钮"
                    @click="openCurrentPage()"
                  ></div>
                  <div class="describe weather"></div>
                  <div class="describe describe-1"></div>
                  <div class="describe describe-2"></div>
                  <div class="describe describe-3"></div>
                  <div class="describe describe-4"></div>
                  <div :class="'btn-box btn-box-' + pageAniAll[4].select">
                    <div
                      class="describe describe-5"
                      @click="thisPage(3, 1)"
                    ></div>
                    <div
                      class="describe describe-6"
                      @click="thisPage(3, 2)"
                    ></div>
                  </div>
                  <div
                    :class="
                      'describe describe-7 describe-select-' +
                        pageAniAll[4].select
                    "
                  ></div>
                  <div :class="'subpage-page subpage-' + pageAniAll[4].select">
                    <div
                      v-if="diary_list[1].is_get == 0"
                      :class="
                        'describe describe-8 call-to-mind-btn lqjl-' +
                          diary_list[1].is_yes
                      "
                      @click="resultPage(3, diary_list[1].is_yes, 2)"
                    >
                      <b>剩余次数：{{ activeInfo.retry_time }}</b>
                    </div>
                    <div
                      v-else
                      class="describe describe-8 call-to-mind-btn ylq-btn"
                    ></div>
                    <div
                      v-if="diary_list[1].is_yes == 1"
                      :class="
                        'describe jump-page jump-select-' + diary_list[1].is_yes
                      "
                      @click="jumpPage(pageAniAll[3].select, 3)"
                    ></div>
                  </div>
                </div>
                <div
                  v-if="activeInfo.number == 2"
                  :class="'daily-task-btn daily-' + is_get + ' task-' + my_get"
                  @click="everyday()"
                ></div>
                <div class="bottom-number">4/13</div>
              </div>
              <div
                class="page page-5"
                :style="{ 'z-index': 13 }"
                title="第三篇-上"
              >
                <div :class="'page-ani-5 page-ani-' + pageAniAll[5].ani">
                  <div
                    :class="'date-label-btn red-' + is_red"
                    title="日期标签按钮"
                    @click="openCurrentPage()"
                  ></div>
                  <div class="describe weather2"></div>
                  <div class="describe describe-1"></div>
                  <div class="describe describe-2"></div>
                  <div class="describe describe-3"></div>
                  <div class="describe describe-4"></div>
                  <div
                    class="describe jump-page jump-select-1"
                    @click="jumpPage(1, 6)"
                  ></div>
                </div>
                <div class="bottom-number">5/13</div>
              </div>
              <div
                class="page page-6"
                :style="{ 'z-index': 12 }"
                title="第三篇-下"
              >
                <div :class="'page-ani-6 page-ani-' + pageAniAll[6].ani">
                  <div
                    :class="'date-label-btn red-' + is_red"
                    title="日期标签按钮"
                    @click="openCurrentPage()"
                  ></div>
                  <div class="describe weather2"></div>
                  <div class="describe describe-1"></div>
                  <div :class="'btn-box btn-box-' + pageAniAll[5].select">
                    <div
                      class="describe describe-2"
                      @click="thisPage(4, 2)"
                    ></div>
                    <div
                      class="describe describe-3"
                      @click="thisPage(4, 1)"
                    ></div>
                  </div>
                  <div
                    :class="
                      'describe describe-4 describe-select-' +
                        pageAniAll[5].select
                    "
                  ></div>
                  <div :class="'subpage-page subpage-' + pageAniAll[5].select">
                    <div class="describe describe-5"></div>
                    <div class="describe describe-6"></div>
                    <div class="describe describe-7"></div>
                    <div class="describe describe-8"></div>
                    <div class="describe describe-9"></div>
                    <div
                      v-if="diary_list[2].is_get == 0"
                      :class="
                        'describe describe-10 call-to-mind-btn lqjl-' +
                          diary_list[2].is_yes
                      "
                      @click="resultPage(5, diary_list[2].is_yes, 3)"
                    >
                      <b>剩余次数：{{ activeInfo.retry_time }}</b>
                    </div>
                    <div
                      v-else
                      class="describe describe-10 call-to-mind-btn ylq-btn"
                    ></div>
                    <div
                      v-if="diary_list[2].is_yes == 1"
                      :class="
                        'describe jump-page jump-select-' + diary_list[2].is_yes
                      "
                      @click="jumpPage(pageAniAll[5].select, 5)"
                    ></div>
                  </div>
                </div>
                <div
                  v-if="activeInfo.number == 3"
                  :class="'daily-task-btn daily-' + is_get + ' task-' + my_get"
                  @click="everyday()"
                ></div>
                <div class="bottom-number">6/13</div>
              </div>
              <div
                class="page page-7"
                :style="{ 'z-index': 11 }"
                title="第四篇-上"
              >
                <div :class="'page-ani-7 page-ani-' + pageAniAll[7].ani">
                  <div
                    :class="'date-label-btn red-' + is_red"
                    title="日期标签按钮"
                    @click="openCurrentPage()"
                  ></div>
                  <div class="describe weather"></div>
                  <div class="describe describe-1"></div>
                  <div class="describe describe-2"></div>
                  <div class="describe describe-3"></div>
                  <div class="describe describe-4"></div>
                  <div class="describe describe-5"></div>
                  <div :class="'btn-box btn-box-' + pageAniAll[7].select">
                    <div
                      class="describe describe-7"
                      @click="thisPage(5, 1)"
                    ></div>
                    <div
                      class="describe describe-8"
                      @click="thisPage(5, 2)"
                    ></div>
                  </div>
                  <div
                    :class="
                      'describe describe-9 describe-select-' +
                        pageAniAll[7].select
                    "
                  ></div>
                  <div
                    :class="
                      'describe jump-page jump-select-' + pageAniAll[7].select
                    "
                    @click="jumpPage(pageAniAll[7].select, 8)"
                  ></div>
                </div>
                <div class="bottom-number">7/13</div>
              </div>
              <div
                class="page page-8"
                :style="{ 'z-index': 10 }"
                title="第四篇-下"
              >
                <div :class="'page-ani-8 page-ani-' + pageAniAll[8].ani">
                  <div
                    :class="'date-label-btn red-' + is_red"
                    title="日期标签按钮"
                    @click="openCurrentPage()"
                  ></div>
                  <div class="describe weather"></div>
                  <div class="describe describe-1"></div>
                  <div class="describe describe-2"></div>
                  <div class="describe describe-3"></div>
                  <div class="describe describe-4"></div>
                  <div class="describe describe-5"></div>
                  <div :class="'btn-box btn-box-' + pageAniAll[8].select">
                    <div
                      class="describe describe-7"
                      @click="thisPage(6, 1)"
                    ></div>
                    <div
                      class="describe describe-8"
                      @click="thisPage(6, 2)"
                    ></div>
                  </div>
                  <div
                    :class="
                      'describe describe-9 describe-select-' +
                        pageAniAll[8].select
                    "
                  ></div>
                  <div :class="'subpage-page subpage-' + pageAniAll[8].select">
                    <div
                      v-if="diary_list[3].is_get == 0"
                      :class="
                        'describe describe-10 call-to-mind-btn lqjl-' +
                          diary_list[3].is_yes
                      "
                      @click="resultPage(7, diary_list[3].is_yes, 4)"
                    >
                      <b>剩余次数：{{ activeInfo.retry_time }}</b>
                    </div>
                    <div
                      v-else
                      class="describe describe-10 call-to-mind-btn ylq-btn"
                    ></div>
                    <div
                      v-if="diary_list[3].is_yes == 1"
                      :class="
                        'describe jump-page jump-select-' + diary_list[3].is_yes
                      "
                      @click="jumpPage(pageAniAll[7].select, 7)"
                    ></div>
                  </div>
                </div>
                <div
                  v-if="activeInfo.number == 4"
                  :class="'daily-task-btn daily-' + is_get + ' task-' + my_get"
                  @click="everyday()"
                ></div>
                <div class="bottom-number">8/13</div>
              </div>
              <div class="page page-9" :style="{ 'z-index': 9 }" title="第五篇">
                <div :class="'page-ani-9 page-ani-' + pageAniAll[9].ani">
                  <div
                    :class="'date-label-btn red-' + is_red"
                    title="日期标签按钮"
                    @click="openCurrentPage()"
                  ></div>
                  <div class="describe weather"></div>
                  <div class="describe describe-1"></div>
                  <div class="describe describe-2"></div>
                  <div class="describe describe-3"></div>
                  <div :class="'btn-box btn-box-' + pageAniAll[9].select">
                    <div
                      class="describe describe-4"
                      @click="thisPage(7, 2)"
                    ></div>
                    <div
                      class="describe describe-5"
                      @click="thisPage(7, 1)"
                    ></div>
                  </div>
                  <div
                    :class="
                      'describe describe-6 describe-select-' +
                        pageAniAll[9].select
                    "
                  ></div>
                  <div :class="'subpage-page subpage-' + pageAniAll[9].select">
                    <div class="describe describe-7"></div>
                    <div class="describe describe-8"></div>
                    <div
                      v-if="diary_list[4].is_get == 0"
                      :class="
                        'describe describe-9 call-to-mind-btn lqjl-' +
                          diary_list[4].is_yes
                      "
                      @click="resultPage(9, diary_list[4].is_yes, 5)"
                    >
                      <b>剩余次数：{{ activeInfo.retry_time }}</b>
                    </div>
                    <div
                      v-else
                      class="describe describe-9 call-to-mind-btn ylq-btn"
                    ></div>
                  </div>
                </div>
                <div
                  v-if="activeInfo.number == 5"
                  :class="'daily-task-btn daily-' + is_get + ' task-' + my_get"
                  @click="everyday()"
                ></div>
                <div class="bottom-number">9/13</div>
              </div>
              <div
                class="page page-10"
                :style="{ 'z-index': 8 }"
                title="第六篇-上"
              >
                <div :class="'page-ani-10 page-ani-' + pageAniAll[10].ani">
                  <div
                    :class="'date-label-btn red-' + is_red"
                    title="日期标签按钮"
                    @click="openCurrentPage()"
                  ></div>
                  <div class="describe weather"></div>
                  <div class="describe describe-1"></div>
                  <div class="describe describe-2"></div>
                  <div class="describe describe-3"></div>
                  <div class="describe describe-4"></div>
                  <div class="describe describe-5"></div>
                  <div class="describe describe-6"></div>
                  <div :class="'btn-box btn-box-' + pageAniAll[10].select">
                    <div
                      class="describe describe-7"
                      @click="thisPage(10, 1)"
                    ></div>
                    <div
                      class="describe describe-8"
                      @click="thisPage(10, 1)"
                    ></div>
                  </div>
                  <div
                    :class="
                      'describe describe-9 describe-select-' +
                        pageAniAll[10].select
                    "
                  ></div>
                  <div
                    :class="
                      'describe jump-page jump-select-' + pageAniAll[10].select
                    "
                    @click="jumpPage(pageAniAll[10].select, 11)"
                  ></div>
                </div>
                <div class="bottom-number">10/13</div>
              </div>
              <div
                class="page page-11"
                :style="{ 'z-index': 7 }"
                title="第六篇-下"
              >
                <div :class="'page-ani-11 page-ani-' + pageAniAll[11].ani">
                  <div
                    :class="'date-label-btn red-' + is_red"
                    title="日期标签按钮"
                    @click="openCurrentPage()"
                  ></div>
                  <div class="describe weather2"></div>
                  <div class="describe describe-1"></div>
                  <div class="describe describe-2"></div>
                  <div class="describe describe-3"></div>
                  <div class="describe describe-4"></div>
                  <div class="describe describe-5"></div>
                  <div
                    v-if="diary_list[5].is_get == 0"
                    :class="
                      'describe describe-6 call-to-mind-btn lqjl-' +
                        diary_list[5].is_yes
                    "
                    @click="resultPage(12, diary_list[5].is_yes, 6)"
                  >
                    <b>剩余次数：{{ activeInfo.retry_time }}</b>
                  </div>
                  <div
                    v-else
                    class="describe describe-6 call-to-mind-btn ylq-btn"
                  ></div>
                  <div
                    v-if="diary_list[5].is_yes == 1"
                    :class="
                      'describe jump-page jump-select-' + diary_list[5].is_yes
                    "
                    @click="jumpPage(pageAniAll[10].select, 10)"
                  ></div>
                </div>
                <div
                  v-if="activeInfo.number == 6"
                  :class="'daily-task-btn daily-' + is_get + ' task-' + my_get"
                  @click="everyday()"
                ></div>
                <div class="bottom-number">11/13</div>
              </div>
              <div
                class="page page-12"
                :style="{ 'z-index': 6 }"
                title="第七篇-上"
              >
                <div :class="'page-ani-12 page-ani-' + pageAniAll[12].ani">
                  <div
                    :class="'date-label-btn red-' + is_red"
                    title="日期标签按钮"
                    @click="openCurrentPage()"
                  ></div>
                  <div class="describe weather"></div>
                  <div class="describe describe-1"></div>
                  <div class="describe describe-2"></div>
                  <div class="describe describe-3"></div>
                  <div :class="'btn-box btn-box-' + pageAniAll[12].select">
                    <div
                      class="describe describe-4"
                      @click="thisPage(12, 1)"
                    ></div>
                    <div
                      class="describe describe-5"
                      @click="thisPage(12, 2)"
                    ></div>
                  </div>
                  <div
                    :class="
                      'describe describe-6 describe-select-' +
                        pageAniAll[12].select
                    "
                  ></div>
                  <div :class="'subpage-page subpage-' + pageAniAll[12].select">
                    <div class="describe describe-7"></div>
                    <div class="describe describe-8"></div>
                    <div class="describe describe-9"></div>
                    <div class="describe describe-10"></div>
                    <div
                      :class="
                        'describe jump-page jump-select-' +
                          pageAniAll[12].select
                      "
                      @click="jumpPage(pageAniAll[12].select, 13)"
                    ></div>
                  </div>
                </div>
                <div class="bottom-number">12/13</div>
              </div>
              <div
                class="page page-13"
                :style="{ 'z-index': 5 }"
                title="第七篇-下"
              >
                <div :class="'page-ani-13 page-ani-' + pageAniAll[13].ani">
                  <div
                    :class="'date-label-btn red-' + is_red"
                    title="日期标签按钮"
                    @click="openCurrentPage()"
                  ></div>
                  <div class="describe weather"></div>
                  <div class="describe describe-1"></div>
                  <div class="describe describe-2"></div>
                  <div class="describe describe-3"></div>
                  <div class="describe describe-4"></div>
                  <div class="describe describe-5"></div>
                  <div class="describe describe-6"></div>
                  <div :class="'subpage-page subpage-' + pageAniAll[12].select">
                    <div
                      v-if="diary_list[6].is_get == 0"
                      :class="
                        'describe describe-10 call-to-mind-btn lqjl-' +
                          diary_list[6].is_yes
                      "
                      @click="resultPage(12, diary_list[6].is_yes, 7)"
                    >
                      <b>剩余次数：{{ activeInfo.retry_time }}</b>
                    </div>
                    <div
                      v-else
                      class="describe describe-10 call-to-mind-btn ylq-btn"
                    ></div>
                    <div
                      v-if="diary_list[6].is_yes == 1"
                      :class="
                        'describe jump-page jump-select-' + diary_list[6].is_yes
                      "
                      @click="jumpPage(pageAniAll[12].select, 12)"
                    ></div>
                  </div>
                </div>
                <div
                  v-if="activeInfo.number == 7"
                  :class="'daily-task-btn daily-' + is_get + ' task-' + my_get"
                  @click="everyday()"
                ></div>
                <div class="bottom-number">13/13</div>
              </div>
            </div>
          </div>
          <div class="main-page page-diary-2">
            <div class="my-diary-box">
              <div class="page">
                <div class="reward-details">
                  <div class="reward-main">
                    <h2 class="reward-title"></h2>
                    <ul>
                      <li
                        :class="'li-' + item"
                        v-for="(item, i) in reward_list"
                        :key="i"
                      ></li>
                    </ul>
                  </div>
                  <div class="tb-reward-main reward-main">
                    <h2 class="reward-title"></h2>
                    <ul>
                      <li
                        :class="'li-' + item"
                        v-for="(item, i) in day_reward_list"
                        :key="i"
                      ></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="main-page page-diary-3">
            <div class="my-diary-box">
              <div class="page">
                <div class="item-details">
                  <div class="details-and-help">
                    <div class="details-box">
                      <h2 class="det-title"></h2>
                      <div class="rule-img"></div>
                    </div>
                    <div class="help-box">
                      <h2 class="det-title"></h2>
                      <div class="help-list" v-if="friend_list.length > 0">
                        <div class="h-tips">今日收到了以下好朋友的帮助</div>
                        <ul>
                          <li v-for="(item, i) in friend_list" :key="i">
                            <img :src="item.avatar" />
                            <span>{{ item.nickname }}</span>
                            <strong>{{ item.created_at }}</strong>
                            <strong>重温次数 + 1</strong>
                          </li>
                        </ul>
                      </div>
                      <div v-else class="null-data"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 分享相关DOM -->
    <div class="share-box" ref="imageDom">
      <img
        src="https://download4.qcplay.com/h5-images/active/servitor/nmrj/help_wrap/help_share_img.png"
      />
      <div class="share-img">
        <div class="url-box">
          <p>{{ shareLink2 }}</p>
        </div>
        <div class="qrcode-box">
          <div id="qrcode" class="qrcode"></div>
        </div>
      </div>
    </div>

    <!-- 页数选择弹窗 -->
    <div class="number-pages-wrap popup_wrap" v-show="numberShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="number-pages-box popup_wrap-box" v-show="numberShow">
          <ul :class="'ul-' + showNumber">
            <li
              :class="'li-' + item.status + ' type-' + item.complete"
              v-for="(item, i) in numberPagesList"
              :key="i"
              @click="currentPage(item.status, item.page, i)"
            >
              {{ item.info }}
            </li>
          </ul>
          <div class="close-btn" @click="numberShow = false"></div>
        </div>
      </transition>
    </div>

    <!-- 今日是否能领取奖励（是否登录过游戏） -->
    <div class="daily-task-popup popup_wrap" v-show="dailyTaskShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="daily-task-box popup_wrap-box" v-show="dailyTaskShow">
          <div class="daily-btn" @click="closeDailyTask()"></div>
          <div class="close-btn" @click="dailyTaskShow = false"></div>
        </div>
      </transition>
    </div>

    <!-- 每日游戏登录奖励 -->
    <div
      :class="'mrdl-popup popup_wrap mrdl-' + this.showNumber"
      v-show="mrdlShow"
    >
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="mrdl-box popup_wrap-box" v-show="mrdlShow">
          <div class="close-btn" @click="mrdlShow = false"></div>
        </div>
      </transition>
    </div>

    <!-- 每篇日记完美完成 -->
    <div :class="'rj-popup popup_wrap rj-' + this.showNumber" v-show="rjShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="rj-box popup_wrap-box" v-show="rjShow">
          <div class="close-btn" @click="rjShow = false"></div>
        </div>
      </transition>
    </div>

    <!-- 分享弹窗 -->
    <div class="help-share-wrap popup_wrap">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="help-share-box popup_wrap-box">
          <img :src="shareImg" alt="分享图片" />
          <button
            class="monitor-btn"
            @click="onCopy()"
            id="clipboard-btn"
            data-event="复制邀请链接"
            :data-clipboard-text="
              '求助力~帮我重温诺米的回忆吧！点击助力《使魔计划》活动：' +
                shareLink2
            "
          ></button>
          <div class="close-bg" @click="closeShare()"></div>
          <div class="close-btn" @click="closeShare()"></div>
        </div>
      </transition>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
    <div :class="'prevent-wrap prevent-wrap-' + maskShow"></div>
  </div>
</template>
<script>
import { Toast } from "mint-ui";
import Clipboard from "clipboard";
import { mapState, mapMutations, mapActions } from "vuex";
import Os from "@/components/os";
import Login from "@/components/login";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { headerConfig } from "../headerConfig";
import {
  onGetInitDataAPI,
  performTasksAPI,
  receiveDailyRewardsAPI,
  lotteryUpdateAPI,
  retryAPI
} from "../api";
import { getRandomString, buriedLogger } from "@/utils/utils";
import { generateQRCode, generateCanvasImage } from "@/utils/share";

export default {
  name: "nmrj",
  components: {
    Header,
    Footer,
    Login,
    Os
  },
  data() {
    return {
      headerConfig,
      gameName: "servitor",
      icon_img:
        "https://download4.qcplay.com/qcgame-admin/f4662HDaVOq8pLVvcJPHgSVdVkrnpv8mJmCWaQz4.jpg",
      downloadUrl: "https://smjh.qingcigame.com/official/",
      preloadingShow: true,
      maskShow: false, // 防止先点击的延迟遮罩
      titleShow: true,
      shareLink: "",
      shareLink2: "",
      // 开启按钮动画
      openBtnS: false,
      shareImg: null,
      // 分享弹窗
      shareShow: false,
      // 页数选择弹窗
      numberShow: false,
      // 全屏遮罩
      preventShow: false,
      // 今日是否能领取奖励（是否登录过游戏）
      dailyTaskShow: false,
      // 每日登录奖励弹窗
      mrdlShow: false,
      // 日记奖励弹窗
      rjShow: false,
      // 其他数据
      loginTypes: ["sms", "password"],
      diaryState: "",
      // 日记封面状态
      turnpageState: "",
      navNum: 1,
      pageNum: 1,
      showNumber: 1,
      // 能不能领取每日奖励
      my_get: false,
      // 有没有领过每日奖励
      is_get: false,
      // 红点
      is_red: false,
      // 每次答题的存储
      answerAll: "",
      pageAniAll: [
        {},
        { ani: false, page: 1, select: "" }, // 第一题第一页动画
        { ani: false, page: 2, select: "" }, // 第一题第二页动画
        { ani: false, page: 3, select: "" }, // 第二题第一页动画
        { ani: false, page: 4, select: "" }, // 第二题第二页动画
        { ani: false, page: 5, select: "" }, // 第三题第一页动画
        { ani: false, page: 6, select: "" }, // 第三题第二页动画
        { ani: false, page: 7, select: "" }, // 第四题第一页动画
        { ani: false, page: 8, select: "" }, // 第四题第二页动画
        { ani: false, page: 9, select: "" }, // 第五题一页动画---
        { ani: false, page: 10, select: "" }, // 第六题第一页动画
        { ani: false, page: 11, select: "" }, // 第六题第二页动画
        { ani: false, page: 12, select: "" }, // 第七题第一页动画
        { ani: false, page: 13, select: "" } // 第七题第二页动画
      ],
      numberPagesList: [
        { info: "第一篇", page: "1", status: false, complete: "" },
        { info: "第二篇", page: "3", status: false, complete: "" },
        { info: "第三篇", page: "5", status: false, complete: "" },
        { info: "第四篇", page: "7", status: false, complete: "" },
        { info: "第五篇", page: "9", status: false, complete: "" },
        { info: "第六篇", page: "10", status: false, complete: "" },
        { info: "第七篇", page: "12", status: false, complete: "" }
      ],
      // 模拟数据
      diary_list: [
        { is_error: 0, is_yes: 0, is_answer: [0, 0] },
        { is_error: 0, is_yes: 0, is_answer: [0, 0] },
        { is_error: 0, is_yes: 0, is_answer: [0] },
        { is_error: 0, is_yes: 0, is_answer: [0] },
        { is_error: 0, is_yes: 0, is_answer: [0, 0] },
        { is_error: 0, is_yes: 0, is_answer: [0, 0] },
        { is_error: 0, is_yes: 0, is_answer: [1] }
      ],
      // 日记奖励
      reward_list: [],
      // 每日特殊奖励
      day_reward_list: [],
      // 帮助列表
      friend_list: []
    };
  },
  created() {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    setTimeout(() => {
      onGetInitDataAPI().then(response => {
        if (Number(response.code) == 200) {
          // 题目是否答题过
          this.diary_list = response.data.activity.diary_list;
          this.showNumber = this.activeInfo.now_number;
        }
        this.onInitDataCallback(response);
        this.preloadingShow = false;
      });

      // this.preloadingShow = false;
    }, 1500);

    // 埋点
    const bl = buriedLogger("servitor", "使魔3月份H5活动_活动页");
    this.logger = bl;
  },
  mounted() {},
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.user_id) {
          this.osCancell();
          // TAG: 注销的时候
        } else if (newValue.user_id !== oldValue.user_id) {
          // TAG: 初始登陆/切换角色的时候
          this.initShareData(newValue);
        }
      }
    },
    activeInfo: {
      handler(newValue, oldValue) {
        console.log("newValue", newValue);
        console.log("oldValue", oldValue);
        if (!newValue.diary_list) {
          // TAG: 注销的时候
        } else if (newValue.diary_list !== oldValue.diary_list) {
          // 答案列表
          this.diary_list = newValue.diary_list;
          // 每日日记奖励
          this.reward_list = newValue.reward_list;
          // 每日特殊奖励
          this.day_reward_list = newValue.day_reward_list;
          // 当天奖励是否能领取
          this.my_get = newValue._get;
          // 是否领过当天奖励
          this.is_get = newValue.is_get;
          // 红点
          this.is_red = this.activeInfo.is_red;
          // 助力列表
          this.friend_list = newValue.friend_list;
        }
      }
    }
  },
  methods: {
    initShareData(info) {
      const { protocol, host } = window.location;
      this.shareLink = `${protocol}//${host}/servitor/nmrj/enter${getRandomString()}`;
      this.shareLink2 = `${protocol}//${host}/servitor/nmrj/help${getRandomString()}?id=${
        info.user_id
      }`;
      try {
        setTimeout(() => {
          this.setShare({
            title: "诺米的日记 -《使魔计划》",
            desc: "打开诺米的日记，一起重温她的回忆吧~惊喜奖励等你领取哦！",
            imgUrl: this.icon_img,
            link: this.shareLink
          });
        }, 2000);
        this.qrcode(this.shareLink2);
        this.$nextTick(() => {
          this.generateShareImage();
        });
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        console.log("err", err);
      }
    },
    // 选择角色后
    selectCallback() {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
        this.osCancell();
      });
    },
    // 区组弹窗注销-相关参数复位
    osCancell() {
      // 关闭书本
      this.turnpageState = "";
      setTimeout(() => {
        this.diaryState = "";
        this.openBtnS = true;
        this.showDiary(false);
      }, 1000);
    },
    // TAG: 相关业务方法
    onInvite() {
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
    },
    qrcode(link) {
      generateQRCode(document.getElementById("qrcode"), {
        text: link,
        colorDark: "#b8957e",
        colorLight: "#f3eadb"
      });
    },
    // 分享图片设置
    generateShareImage() {
      generateCanvasImage(this.$refs.imageDom)
        .then(canvas => {
          this.shareImg = canvas.toDataURL("image/png"); // 可将 canvas 转为 base64 格式
          console.log("success: 图片生成成功");
        })
        .catch(err => {
          console.log("err: 图片生成失败", err.message);
        });
    },
    // 复制链接
    onCopy() {
      const clipboard = new Clipboard("#clipboard-btn");
      clipboard.on("success", e => {
        Toast({ message: "复制成功", duration: 1000, className: "toasts" });
        e.clearSelection();
      });
      clipboard.on("error", e => {
        Toast({ message: "复制失败", duration: 1000, className: "toasts" });
      });
      this.logger.sum("使魔3月份H5活动_复制按钮");
    },
    // 日记 && 奖励 && 详情 翻页按钮
    turnPagesBtn(i) {
      this.navNum = i;
    },
    // 滑动监控
    vueTouch(txt, e) {
      if (txt == "left") {
        if (13 > this.pageNum) {
          this.pageNum = this.pageNum + 1;
        }
      } else {
        // 页面不能小于0
        if (this.pageNum > 1) {
          this.pageNum = this.pageNum - 1;
          return;
        }
        // 关闭书本
        this.turnpageState = "";
        setTimeout(() => {
          this.diaryState = "";
        }, 1000);
      }
    },
    // 查看日期日记
    currentPage(status, page, i) {
      if (!status) {
        Toast({
          message: "非常抱歉，日记暂未开启！",
          duration: 1000,
          className: "toasts"
        });
        return;
      }
      this.preventShow = true; // 遮罩弹窗
      this.numberShow = false; // 关闭弹窗
      setTimeout(() => {
        this.pageNum = page;
        this.pageAniAll[this.pageNum].ani = false;
        setTimeout(() => {
          this.judgmentDiary(Number(i + 1));
          setTimeout(() => {
            this.preventShow = false;
          }, 3000);
        }, 500);
      }, 500);
    },
    // 点击开启日记
    openBtn() {
      // this.$nextTick(() => {
      //   this.diaryState = true;
      //   setTimeout(() => {
      //     this.turnpageState = true;
      //   }, 1000);
      // });

      // 是否登录
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
      this.$nextTick(() => {
        this.preventShow = true;
        this.diaryState = true;
        setTimeout(() => {
          this.preventShow = false;
          this.turnpageState = true;
          // 当天是第几天[1-7]
          this.showNumber = this.activeInfo.now_number;
          // this.showNumber = 4;
          // 当天奖励是否能领取
          this.my_get = this.activeInfo._get;
          // 是否领过当天奖励
          this.is_get = this.activeInfo.is_get;
          // 每日日记奖励
          this.reward_list = this.activeInfo.reward_list;
          // 每日特殊奖励
          this.day_reward_list = this.activeInfo.day_reward_list;
          // 红点
          this.is_red = this.activeInfo.is_red;
          // 助力列表
          this.friend_list = this.activeInfo.friend_list;
          // 最新日期切换弹窗中的完成情况
          for (var i = 0; i <= this.activeInfo.reward_list.length - 1; i++) {
            this.numberPagesList[i].complete = this.activeInfo.reward_list[i];
          }
          // 开启指定日记
          this.judgmentDiary(this.showNumber);
          // 阿里云埋点
          this.logger.sum("使魔3月份H5活动_点击开启按钮");
          this.logger.sum(
            "使魔3月份H5活动_第" + this.showNumber + "天,点击开启按钮"
          );
        }, 1000);
      });
    },
    // 展示日记
    showDiary(status) {
      for (var i = 0; i <= 13; i++) {
        this.pageAniAll[i].ani = status;
        this.pageAniAll[i].select = status;
      }
    },
    // 相关动画
    isAnswer(times_1, times_2, select_num) {
      this.pageAniAll[this.pageNum].ani = false;
      this.pageAniAll[this.pageNum].select = "";
      setTimeout(() => {
        this.pageAniAll[this.pageNum].ani = true;
        setTimeout(() => {
          this.pageAniAll[this.pageNum].select = select_num;
        }, times_2);
      }, times_1);
    },
    isAnswer2(times_1, times_2, select_num) {
      this.pageAniAll[this.pageNum].ani = false;
      setTimeout(() => {
        this.pageAniAll[this.pageNum].ani = true;
        setTimeout(() => {
          this.pageAniAll[this.pageNum].select = "";
          this.pageAniAll[this.pageNum].select = select_num;
        }, times_2);
      }, times_1);
    },
    // 子页面翻页优化
    delayedClickMask2(page) {
      const delayedConfig = {
        2: 3,
        4: 4,
        8: 5,
        11: 6,
        13: 6
      };
      if (delayedConfig[page]) {
        this.maskShow = true;
        setTimeout(() => {
          this.maskShow = false;
        }, delayedConfig[page] * 1000);
      }
    },
    // 子页面中翻页（可优化）
    jumpPage(i, is_this) {
      console.log(i);
      console.log(is_this);
      this.delayedClickMask2(is_this);
      if (i >= 1) {
        this.pageNum = is_this;
        this.pageAniAll[this.pageNum].ani = true;
        if (is_this == 1) {
          // 第一题，第2页特殊判断
          if (this.diary_list[0].is_yes !== 0) {
            this.isAnswer(500, 3500, 1);
          }
          if (this.diary_list[0].is_error !== 0) {
            this.isAnswer(500, 3500, this.diary_list[0].is_answer[1]);
          }
          return;
        }
        if (is_this == 2) {
          // 第一题，第2页特殊判断
          if (this.diary_list[0].is_yes !== 0) {
            this.isAnswer(500, 2000, 1);
          }
          if (this.diary_list[0].is_error !== 0) {
            this.isAnswer(500, 2000, this.diary_list[0].is_answer[1]);
          }
          return;
        }
        if (is_this == 4 || is_this == 3) {
          // 第二题，第4页特殊判断
          if (this.diary_list[1].is_yes !== 0) {
            this.isAnswer(500, 2500, 1);
          }
          if (this.diary_list[1].is_error !== 0) {
            this.isAnswer(500, 2500, this.diary_list[1].is_answer[1]);
          }
          return;
        }
        if (is_this == 6 || is_this == 5) {
          // 第三题，第6页特殊判断
          if (this.diary_list[2].is_yes !== 0) {
            this.isAnswer2(500, 1000, 1);
          }
          if (this.diary_list[2].is_error !== 0) {
            this.isAnswer2(500, 1000, this.diary_list[2].is_answer[1]);
          }
          return;
        }
        if (is_this == 8 || is_this == 7) {
          // 第四题，第8页特殊判断
          if (this.diary_list[3].is_yes !== 0) {
            this.isAnswer(500, 3000, 1);
          }
          if (this.diary_list[3].is_error !== 0) {
            this.isAnswer(500, 3000, this.diary_list[3].is_answer[1]);
          }
          return;
        }
        if (is_this == 11 || is_this == 10) {
          // 第六题，第8页特殊判断
          if (this.diary_list[4].is_yes !== 0) {
            this.isAnswer(500, 3500, 1);
          }
          if (this.diary_list[4].is_error !== 0) {
            this.isAnswer(500, 3500, 2);
          }
          return;
        }
        if (is_this == 9) {
          // 第五题
          if (this.diary_list[5].is_yes !== 0) {
            this.isAnswer(500, 2000, 1);
          }
          if (this.diary_list[5].is_error !== 0) {
            this.isAnswer(500, 2000, 2);
          }
          return;
        }
        if (is_this == 13 || is_this == 12) {
          //第七题
          if (this.diary_list[6].is_yes !== 0) {
            this.isAnswer(500, 2000, 1);
          }
          if (this.diary_list[6].is_error !== 0) {
            this.isAnswer(500, 2000, 2);
          }
          return;
        }
      }
    },
    // 延迟点击遮罩
    delayedClickMask(number) {
      if (number !== 3) {
        this.maskShow = true;
        const delayedConfig = {
          1: 5.5,
          2: 4.5,
          4: 5.5,
          5: 4,
          6: 6,
          7: 4
        };
        const times = delayedConfig[number];
        setTimeout(() => {
          this.maskShow = false;
        }, times * 1000);
      }
    },
    // 判断日记天数
    judgmentDiary(number) {
      this.showDiary(false);
      this.showNumber = number;
      this.delayedClickMask(number);
      if (number == 1) {
        // 查看第一篇是否都答题正确过
        if (this.diary_list[Number(number - 1)].is_yes !== 0) {
          setTimeout(() => {
            this.pageAniAll[1].select = 1;
          }, 3500);
        } else {
          if (this.diary_list[Number(number - 1)].is_error !== 0) {
            setTimeout(() => {
              this.pageAniAll[1].select = this.diary_list[0].is_answer[0];
            }, 3500);
          } else {
            this.pageAniAll[2].select = false;
            this.pageAniAll[1].select = false;
          }
        }
        this.pageNum = 1;
      }
      if (number == 2) {
        // 查看第二篇是否都答题正确过
        if (this.diary_list[Number(number - 1)].is_yes !== 0) {
          setTimeout(() => {
            this.pageAniAll[3].select = 1;
          }, 2500);
        } else {
          if (this.diary_list[Number(number - 1)].is_error !== 0) {
            setTimeout(() => {
              this.pageAniAll[3].select = this.diary_list[1].is_answer[0];
            }, 2500);
          } else {
            this.pageAniAll[3].select = false;
            this.pageAniAll[4].select = false;
          }
        }
        this.pageNum = 3;
      }
      if (number == 3) {
        this.pageAniAll[5].select = this.diary_list[2].is_answer[0];
        this.pageNum = 5;
      }
      if (number == 4) {
        // 查看第四篇是否都答题正确过
        if (this.diary_list[Number(number - 1)].is_yes !== 0) {
          setTimeout(() => {
            this.pageAniAll[7].select = 1;
          }, 3000);
        } else {
          if (this.diary_list[Number(number - 1)].is_error !== 0) {
            setTimeout(() => {
              this.pageAniAll[7].select = this.diary_list[3].is_answer[0];
            }, 2500);
          } else {
            this.pageAniAll[7].select = false;
            this.pageAniAll[8].select = false;
          }
        }
        this.pageAniAll[7].select = false;
        this.pageNum = 7;
      }
      // 查看第五篇答案正确
      if (number == 5) {
        this.pageAniAll[9].select = false;
        if (this.diary_list[Number(number - 1)].is_yes !== 0) {
          setTimeout(() => {
            this.pageAniAll[9].select = 1;
          }, 2000);
        } else {
          if (this.diary_list[Number(number - 1)].is_error !== 0) {
            setTimeout(() => {
              this.pageAniAll[9].select = this.diary_list[4].is_answer[0];
            }, 2000);
          } else {
            this.pageAniAll[9].select = false;
          }
        }
        this.pageNum = 9;
      }
      // 查看第六篇,答题都正确
      if (number == 6) {
        if (this.diary_list[Number(number - 1)].is_yes !== 0) {
          setTimeout(() => {
            this.pageAniAll[10].select = this.diary_list[5].is_answer[0];
          }, 3500);
        }
        this.pageNum = 10;
      }
      // 查看第七篇是否都答题正确过
      if (number == 7) {
        if (this.diary_list[Number(number - 1)].is_yes !== 0) {
          setTimeout(() => {
            this.pageAniAll[12].select = this.diary_list[6].is_answer[0];
          }, 2500);
        } else {
          if (this.diary_list[Number(number - 1)].is_error !== 0) {
            setTimeout(() => {
              this.pageAniAll[12].select = this.diary_list[6].is_answer[0];
            }, 2000);
          } else {
            this.pageAniAll[12].select = false;
          }
        }
        this.pageNum = 12;
      }
      this.pageAniAll[this.pageNum].ani = true;
    },
    // 开启日记列表
    openCurrentPage() {
      this.numberShow = true;
      for (var i = 0; i <= Number(this.activeInfo.number - 1); i++) {
        this.numberPagesList[i].status = true;
      }
    },
    // 本页选择
    thisPage(num, result) {
      if (num === 4) {
        this.maskShow = true;
        setTimeout(() => {
          this.maskShow = false;
        }, 5500);
      }
      var status = "";
      this.answerAll = "";
      this.pageAniAll[this.pageNum].select = result;
      if (num == 1) {
        // 1.都答对   2.错误
        this.pageAniAll[1].select == 1 && this.pageAniAll[2].select == 1
          ? (status = 1)
          : (status = 2);
        this.answerAll = [
          this.pageAniAll[1].select,
          this.pageAniAll[2].select
        ].toString();
        // 前往答题API
        this.answer(1, status, 0, this.answerAll);
      }
      // 第二篇第二页
      if (num == 3) {
        // 1.都答对   2.错误
        this.pageAniAll[3].select == 1 && this.pageAniAll[4].select == 1
          ? (status = 1)
          : (status = 2);
        this.answerAll = [
          this.pageAniAll[3].select,
          this.pageAniAll[4].select
        ].toString();
        // 前往答题API
        this.answer(2, status, 0, this.answerAll);
      }
      if (num == 4) {
        // 第3题，选2后初始化告诉我选中的是0
        console.log(this.pageAniAll);
        this.pageAniAll[5].select = result;
        // 1.都答对   2.错误
        this.pageAniAll[5].select == 1 ? (status = 1) : (status = 2);
        this.answerAll = [this.pageAniAll[5].select].toString();
        console.log(this.pageAniAll);
        // 前往答题API
        this.answer(3, status, 0, this.answerAll);
      }
      // 第四篇第二页
      if (num == 6) {
        // 1.都答对   2.错误
        this.pageAniAll[7].select == 1 && this.pageAniAll[8].select == 1
          ? (status = 1)
          : (status = 2);
        this.answerAll = [
          this.pageAniAll[7].select,
          this.pageAniAll[8].select
        ].toString();
        // 前往答题API
        this.answer(4, status, 0, this.answerAll);
      }
      // 第五篇
      if (num == 7) {
        // 1.都答对   2.错误
        this.pageAniAll[9].select == 1 ? (status = 1) : (status = 2);
        this.answerAll = [this.pageAniAll[9].select].toString();
        // 前往答题API
        this.answer(5, status, 0, this.answerAll);
      }
      // 第六篇第一页
      if (num == 10) {
        // 1.都答对   2.错误
        if (this.pageAniAll[10].select == 1 || this.pageAniAll[10].select == 2)
          status = 1;
        this.answerAll = [this.pageAniAll[10].select].toString();
        // 前往答题API
        this.answer(6, status, 0, this.answerAll);
      }
      // 第七篇第一页
      if (num == 12) {
        // 1.都答对   2.错误
        this.pageAniAll[12].select == 1 ? (status = 1) : (status = 2);
        this.answerAll = [this.pageAniAll[12].select].toString();
        // 前往答题API
        this.answer(7, status, 0, this.answerAll);
      }
    },
    // 答题
    answer(number, status, retry, answer) {
      performTasksAPI({
        number: number,
        status: status,
        retry: retry,
        is_answer: answer
      }).then(response => {
        if (Number(response.code) == 200) {
          onGetInitDataAPI().then(response => {
            this.onInitDataCallback(response);
          });
        }
      });
    },
    // 页面返回(2页回1页，4页回3页，6页回5页，8页回7页，9页单独，11页回10页，13页回12页)
    resultPage(index, changes, is_number) {
      if (changes == 1) {
        // 日记奖励领取API
        this.preventShow = true;
        lotteryUpdateAPI({ number: this.showNumber }).then(response => {
          if (Number(response.code) == 200) {
            this.rjShow = true;
            onGetInitDataAPI().then(response => {
              this.onInitDataCallback(response);
            });
          }
          setTimeout(() => {
            this.preventShow = false;
          }, 500);
        });
        return;
      }
      if (this.activeInfo.retry_time == 0) {
        this.shareShow = true;
        this.setShare({
          title: "诺米的日记 -《使魔计划》",
          desc: "求助力~帮我重温诺米的回忆吧！点击助力《使魔计划》活动",
          imgUrl: this.icon_img,
          link: this.shareLink2
        });
        return;
      } else {
        this.preventShow = true;
        retryAPI({ number: is_number }).then(response => {
          if (Number(response.code) == 200) {
            onGetInitDataAPI().then(response => {
              this.onInitDataCallback(response);
              this.resultContent(index);
            });
          } else {
            this.onToast(response.message);
          }
          setTimeout(() => {
            this.preventShow = false;
          }, 2000);
        });
      }
    },
    resultContent(index) {
      this.pageNum = index;
      // 返回第一页第一篇的动画 || 返回第二页第一篇的动画 || 返回第四页第一篇的动画 || 返回第七页第一篇的动画 || 返回第三页第一篇的动画
      if (
        index == 1 ||
        index == 3 ||
        index == 7 ||
        index == 12 ||
        index == 5 ||
        index == 9
      ) {
        this.pageAniAll[index].ani = false;
        setTimeout(() => {
          // 上一页复位
          this.pageAniAll[index].ani = true;
          this.pageAniAll[index].select = "";
          if (index == 5) {
          }
          // 当前页面复位
          if (index !== 9) {
            setTimeout(() => {
              this.pageAniAll[Number(index + 1)].ani = false;
              this.pageAniAll[Number(index + 1)].select = "";
            }, 1000);
          }
        }, 500);
      }
    },
    everyday() {
      // 当天没有领取还不能领取，因为还没登录过游戏
      if (!this.my_get) {
        this.dailyTaskShow = true;
      } else {
        if (this.is_get) {
          this.onToast("很抱歉，您今天已经领取过了!");
          return;
        }
        // 当天登录过游戏
        this.isReceiveDaily();
      }
    },
    isReceiveDaily() {
      this.preventShow = true;
      receiveDailyRewardsAPI().then(response => {
        if (Number(response.code) == 200) {
          this.mrdlShow = true;
          onGetInitDataAPI().then(response => {
            this.onInitDataCallback(response);
          });
          setTimeout(() => {
            this.preventShow = false;
          }, 2000);
          return;
        }
        this.onToast(response.message);
        setTimeout(() => {
          this.preventShow = false;
        }, 2000);
      });
    },
    // 关闭分享
    closeShare() {
      this.shareShow = false;
      this.setShare({
        title: "诺米的日记 -《使魔计划》",
        desc: "打开诺米的日记，一起重温她的回忆吧~惊喜奖励等你领取哦！",
        imgUrl: this.icon_img,
        link: this.shareLink
      });
    },
    // 刷新页面
    closeDailyTask() {
      window.location.href = this.shareLink;
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: "toasts"
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setActiveInfo",
      "setLogger"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less">
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/servitor/nmrj/index/index.vue